import { ApiModel, ListingSellerDraftModelConverter, ListingSellerDraftModel } from '@steelbuy/ts-shared';
import { usePaginatedQuery } from '../../utils/usePaginatedQuery';

export const MY_DRAFT_LISTING_KEY = 'listings-draft';

const modelConverter = new ListingSellerDraftModelConverter();

const searchListingDraftsMapFn = (data: ListingSellerDraftModel) =>
    modelConverter.toViewModel(data as unknown as ApiModel<ListingSellerDraftModel>);

export const useMyDraftListings = (queryOptions = {}) =>
    usePaginatedQuery<ListingSellerDraftModel>({
        url: '/api/universal/draft-listings',
        requestOptions: {},
        mapFn: searchListingDraftsMapFn,
        queryKey: [MY_DRAFT_LISTING_KEY],
        queryOptions: {
            ...queryOptions,
            refetchOnMount: false,
        },
    });
